import { cva } from 'class-variance-authority';

import s from './Switcher.module.css';

export const switcherVariants = cva(s.switcher, {
  variants: {
    disabled: {
      true: s['switcher--disabled'],
    },
    labelPosition: {
      left: s['switcher--label-left'],
      right: s['switcher--label-right'],
    },
  },
});
